export default __webpack_public_path__ + "static/media/x33-logo-cny.d80a74df.png";